var _ = require("underscore");
var Promise = require("bluebird");

module.exports = function($scope, ngDialog) {

  var vm = this;

  function init() {
    vm.email = $scope.ngDialogData.email;
  }

  $scope.submit = function() {
    $scope.closeThisDialog({ action: "submit" });
  };
  $scope.cancel = function() {
    $scope.closeThisDialog({ action: "cancel" });
  };

  init();
};
